import { alpha } from '@mui/material';
import { AlertColor } from '@mui/material/Alert';
import SxDef from '@core/types/SxDef';

const useSx = (type: AlertColor): SxDef => ({
  root: {
    width: '100%',
    borderRadius: '20px 0 0 20px',
    fontSize: '0.875rem',
    alignItems: 'flex-start',
    boxShadow: 3,
    color: 'white',
    backgroundColor: (theme) =>
      alpha(type === 'error' ? '#d65b5b' : theme.palette[type].main, 0.96),
  },
  title: {
    fontWeight: 600,
    display: 'block',
  },
  message: {
    fontSize: '0.8rem',
    mt: 0.5,
    opacity: 0.9,
  },
});

export default useSx;
